import { render } from "./TvmDealerSpecials.vue?vue&type=template&id=7ad67004&scoped=true"
import script from "./TvmDealerSpecials.js?vue&type=script&lang=js&external"
export * from "./TvmDealerSpecials.js?vue&type=script&lang=js&external"

import "./TvmDealerSpecials.vue?vue&type=style&index=0&id=7ad67004&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ad67004"]])

export default __exports__